import React, { useState, useEffect, Fragment } from "react";

import {
  Button,
  Checkbox,
  Grid,
  CardContent,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Tooltip,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

//icons
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/Delete";
import BackupIcon from "@mui/icons-material/Backup";

//actions
import { SubirArchivosServidor } from "../../../Actions/Utilidades/ManejoArchivosAction";
import { ValidarFormatoArchivo } from "../../../Actions/Utilidades/ValidacionesAction";
import { RutinaLeerArchivoInputFile } from "../../../Utilidades/ManejoArchivos";

import {
  ListadoAdjuntosRequisitos,
  InsertarAdjuntoRequisitos,
  EliminarAdjuntoRequisito,
} from "../../../Actions/Admisiones/AdmisionesReqAdjuntosAction";
import { requisitoAdmisionAceptado } from "../../../Actions/Admisiones/AdmisionesRequisitosAction";
import { EliminarArchivosServidor } from "../../../Actions/Utilidades/ManejoArchivosAction";
import { enlistaArrayCodigosMensajesIdiomas } from "../../../Actions/Generales/IdiomasAction";
import { MostrarMensaje } from "../../../Utilidades/ManejoMensajes";

import { styleTable, StyleHome } from "../../Tool/Style";
import {
  StyledTableCellClass,
  StyledTableRowClass,
  StyledTableRowHeaderClass,
} from "../../../theme/themeTableRow";

import CarpetasAdjuntos from "../../../Configuracion/Llaves/CarpetasAdjuntos";
import { MOBILE } from "../config";

//hook
import { useGlobalState } from "../../../Utilidades/useGlobalState";

import {
  mostrarDialogoEliminarGenerico,
  DialogoEliminarGenerico,
} from "../../ControlUsuario/DialogoEliminarGenerico";

const Input = styled("input")({
  display: "none",
});

const Requisitos = ({
  deviceIs = "DESKTOP",
  Admision,
  ListaRequisitosAdmision,
  FuncionValidaRequisitosDeAdmision,
  Credenciales,
}) => {
  const { etiquetas, dispatch } = useGlobalState();

  useEffect(() => {
    FuncionValidaRequisitosDeAdmision(Admision);
  }, [Admision]);

  const [ObjectId, setObjectId] = useState(
    "00000000-0000-0000-0000-000000000000"
  ); // se encarga del recolectar el identificador del objeto
  const [RelObjectId, setRelObjectId] = useState(
    "00000000-0000-0000-0000-000000000000"
  ); // se encarga del recolectar el identificador del objeto
  const [NombreArchivoEliminar, setNombreArchivoEliminar] = useState(""); // se encarga del recolectar el nombre del objeto

  const SubirArchivoServidor = async (file, requirementId) => {
    let resultado = false;
    const dataObject = {
      FileType: file.tipo,
      FileContent: file.contenido,
      FileSize: file.tamano,
      FileName: file.nombre,
      ObjectId: requirementId,
      FolderName: CarpetasAdjuntos.RequisitosAdmision,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    await SubirArchivosServidor(dataObject).then((response) => {
      if (response.status === 201) {
        //si la respuesta fue existosa
        resultado = true;
      } else {
        if (response.status === 401) {
          MostrarMensaje(dispatch, "error", ["ErrorFile401"]);
        } else if (response.status === 409) {
          MostrarMensaje(dispatch, "warning", ["ErrorFile409"]);
        } else if (response.status === 500) {
          MostrarMensaje(dispatch, "error", ["InternalServerError"]);
        } else if (response.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            response.data.errors
          );
          MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
        } else {
          MostrarMensaje(dispatch, "error", [response.statusText]);
        }
      }
    });

    return resultado;
  };

  const guardarDataArchivo = async (e, requirementId) => {
    const fileInfo = await RutinaLeerArchivoInputFile(e);

    let ProcesarSiguiente = false;

    if (CarpetasAdjuntos.RequisitosAdmision !== "") {
      const dataObject = {
        ElementId: requirementId,
        MimeType: fileInfo.tipo,
        ValidateCode: CarpetasAdjuntos.RequisitosAdmision,
      };

      await ValidarFormatoArchivo(dataObject).then((response) => {
        if (response.status === 200) {
          //si la respuesta fue existosa
          if (response.data === true) {
            ProcesarSiguiente = true;
          } else {
            MostrarMensaje(dispatch, "warning", ["FormartFileError"]);
          }
        } else {
          if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
              response.data.errors
            );
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
          } else {
            MostrarMensaje(dispatch, "error", [response.statusText]);
          }
        }
      });
    } else {
      MostrarMensaje(dispatch, "warning", ["FolderRequisitosAdmision"]);
    }

    if (ProcesarSiguiente) {
      ProcesarSiguiente = await SubirArchivoServidor(fileInfo, requirementId);
    }
    if (ProcesarSiguiente) {
      ProcesarSiguiente = await InsertarArchivo(fileInfo, requirementId);
    }

    if (ProcesarSiguiente) {
      FuncionValidaRequisitosDeAdmision(Admision);
    }
  };

  const inputhandleClick = (event) => {
    const { target = {} } = event || {};
    target.value = "";
  };

  const InsertarArchivo = async (file, requirementId) => {
    let resultado = false;
    const objetoAdjunto = {
      RequirementId: requirementId,
      FileName: file.nombre,
      MimeType: file.tipo,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    const responseInsertarAdjunto = await InsertarAdjuntoRequisitos(
      objetoAdjunto
    );
    if (responseInsertarAdjunto.status === 200) {
      //si la respuesta fue existosa
      MostrarMensaje(dispatch, "success", ["updateOk"]);
      resultado = true;
    } else {
      if (responseInsertarAdjunto.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          responseInsertarAdjunto.data.errors
        );
        MostrarMensaje(
          dispatch,
          responseInsertarAdjunto.data.typeError,
          arrayErrores
        );
      } else {
        MostrarMensaje(dispatch, "error", [responseInsertarAdjunto.statusText]);
      }
    }

    return resultado;
  };

  const EliminarArchivo = async () => {
    const archivoEliminar = {
      FileName: NombreArchivoEliminar,
      FolderName: CarpetasAdjuntos.RequisitosAdmision,
      ObjectId: RelObjectId,
      CompanyId: Credenciales.companyId,
      UserId: Credenciales.userId,
    };

    const responseEliminarAdjuntoServidor = await EliminarArchivosServidor(
      archivoEliminar
    );
    if (responseEliminarAdjuntoServidor.status === 200) {
      //si la respuesta fue existosa
      const objetoEliminar = {
        FileId: ObjectId,
        CompanyId: Credenciales.companyId,
        UserId: Credenciales.userId,
      };

      const responseEliminarAdjunto = await EliminarAdjuntoRequisito(
        objetoEliminar
      );
      if (responseEliminarAdjunto.status === 200) {
        //si la respuesta fue existosa
        MostrarMensaje(dispatch, "success", ["deleteOk"]);
      } else {
        if (responseEliminarAdjunto.data.errors) {
          const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
            responseEliminarAdjunto.data.errors
          );
          MostrarMensaje(
            dispatch,
            responseEliminarAdjunto.data.typeError,
            arrayErrores
          );
        } else {
          MostrarMensaje(dispatch, "error", [
            responseEliminarAdjunto.statusText,
          ]);
        }
      }
    } else {
      if (responseEliminarAdjuntoServidor.data.errors) {
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          responseEliminarAdjuntoServidor.data.errors
        );
        MostrarMensaje(
          dispatch,
          responseEliminarAdjuntoServidor.data.typeError,
          arrayErrores
        );
      } else {
        MostrarMensaje(dispatch, "error", [
          responseEliminarAdjuntoServidor.statusText,
        ]);
      }
    }
  };

  const handleClick = (event, id) => {
    if (id !== "00000000-0000-0000-0000-000000000000") {
      const objeto = {
        RequirementId: id,
      };

      ListadoAdjuntosRequisitos(objeto).then((response) => {
        if (response.status === 200) {
          //si la respuesta fue existosa
          if (response.data.length > 0) {
            EliminaradjuntoClic(
              response.data[0].id,
              response.data[0].relatedIdFk,
              response.data[0].fileName
            );
          }
        } else {
          if (response.data.errors) {
            const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
              response.data.errors
            );
            MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
          } else {
            MostrarMensaje(dispatch, "error", [response.statusText]);
          }
        }
      });
    }
  };

  const EliminaradjuntoClic = (id, relid, nombre) => {
    setObjectId(id);
    setRelObjectId(relid);
    setNombreArchivoEliminar(nombre);
    mostrarDialogoEliminarGenerico();
  };

  const EliminarArchivoEstudiante = async () => {
    await EliminarArchivo();
    await FuncionValidaRequisitosDeAdmision(Admision);
    mostrarDialogoEliminarGenerico();
  };

  const requirementAdmissionAccepted = async (requirementId, checked) => {
    const objReq = {
      requirementId,
      accept: checked,
      companyId: Credenciales.companyId,
      userId: Credenciales.userId,
    };

    const response = await requisitoAdmisionAceptado(objReq);

    if (response.status === 200) {
      MostrarMensaje(dispatch, "success", ["updateOk"]);
      return true;
    } else {
      let hasTrue = true;
      if (response.data.errors) {
        hasTrue = false;
        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(
          response.data.errors
        );
        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
      } else {
        hasTrue = false;
        MostrarMensaje(dispatch, "error", [response.statusText]);
      }

      return hasTrue;
    }
  };

  const handleChangeAccept = async (requirementId, checked) => {
    const result = await requirementAdmissionAccepted(requirementId, checked);
    if (result) {
      await FuncionValidaRequisitosDeAdmision(Admision);
    }
  };

  const abrirNuevoTab = (url) => {
    // Abrir nuevo tab
    var win = window.open(url, "_blank");
    // Cambiar el foco al nuevo tab (punto opcional)
    win.focus();
  };

  return (
    <Fragment>
      <CardContent>
        <Grid
          key="GridRequisitosAdmision"
          container
          style={StyleHome.GridConteiner}
        >
          <Grid item xs={12} sm={12} md={12} style={StyleHome.GridItem}>
            {deviceIs === MOBILE ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {ListaRequisitosAdmision.length > 0
                  ? ListaRequisitosAdmision.map((registro) => (
                      <div key={registro.adrRequirementId + "mobile"}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ marginLeft: "-7px" }}>
                            {registro.aprAcceptRequirement ? (
                              <Checkbox
                                disabled={registro.adrApproved}
                                checked={registro.aprAcceptedByStudent}
                                style={{ padding: "0px 5px" }}
                                name="FileRequired"
                                color="primary"
                                inputProps={{
                                  "aria-label": "secondary checkbox",
                                }}
                                onChange={(e) => {
                                  handleChangeAccept(
                                    registro.aprProgramReqId,
                                    e.target.checked
                                  );
                                }}
                              />
                            ) : null}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_Requisito}
                          </Typography>

                          <div>
                            {!(registro.aprHyperlink === "") &&
                            !(registro.aprHyperlink === null) ? (
                              <Button
                                variant="text"
                                onClick={() =>
                                  abrirNuevoTab(registro.aprHyperlink)
                                }
                                style={{
                                  textTransform: "inherit",
                                  textDecoration: "underline",
                                  color: "#283593",
                                  fontWeight: "normal",
                                }}
                              >
                                {registro.requirementDsc}
                              </Button>
                            ) : (
                              <Typography sx={StyleHome.textSecondary}>
                                {registro.requirementDsc}
                              </Typography>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.Home.Et_lblDocumento}:
                          </Typography>

                          <div>
                            {registro.aprFileRequired === false ? (
                              etiquetas.General.Et_NoAplica
                            ) : (
                              <Tooltip title={etiquetas.Home.Et_lblAdjuntar}>
                                <div>
                                  <label
                                    htmlFor={
                                      "button-file-" +
                                      registro.adrRequirementId
                                    }
                                  >
                                    <Input
                                      id={
                                        "button-file-" +
                                        registro.adrRequirementId
                                      }
                                      type="file"
                                      disabled={registro.adrApproved ||
                                        registro.attachments === true}
                                      onChange={(e) => {
                                        guardarDataArchivo(
                                          e,
                                          registro.adrRequirementId
                                        );
                                      }}
                                      onClick={inputhandleClick}
                                    />
                                    <Button
                                     disabled={
                                        registro.adrApproved ||
                                        registro.attachments === true
                                      }
                                      fullWidth
                                      sx={{
                                        backgroundColor: "#F6F8FB",
                                        color: "#283593",
                                        border: "1px solid #283593",
                                        "&:hover": {
                                          backgroundColor: "#EDF0F4",
                                        },
                                      }}
                                      id="attachments"
                                      variant="contained"
                                      component="span"
                                      disableElevation
                                      startIcon={
                                        <BackupIcon
                                          style={{ color: "#283593" }}
                                        />
                                      }
                                    >
                                      <Typography
                                        noWrap
                                        style={{
                                          color: "#283593",
                                          width: 80,
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        {registro.attachments === true
                                          ? registro.fileName
                                          : etiquetas.Home.Et_lblAdjuntar}
                                      </Typography>
                                    </Button>
                                  </label>
                                </div>
                              </Tooltip>
                            )}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography sx={StyleHome.textPrimary}>
                            {etiquetas.General.Et_tblAcciones}:
                          </Typography>

                          {registro.aprFileRequired === false ? (
                            <IconButton style={styleTable.BodyButtoms} disabled>
                              <BlockIcon fontSize="normal" />
                            </IconButton>
                          ) : (
                            <Tooltip title={etiquetas.General.Et_tbnEliminar}>
                              <IconButton
                                style={styleTable.BodyButtoms}
                                disabled={
                                    registro.attachments === false ||
                                    registro.adrApproved
                                }
                                onClick={(e) => {
                                    handleClick(
                                      e,
                                      registro.adrRequirementId
                                    );
                                  }}
                               
                              >
                                <DeleteIcon fontSize="normal" />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            ) : (
              <TableContainer
                component={Grid}
                style={styleTable.TableConteiner}
              >
                <Table stickyHeader>
                  <TableHead style={styleTable.TableHeader}>
                    <StyledTableRowHeaderClass>
                      <StyledTableCellClass>
                        {etiquetas.General.Et_Requisito}
                      </StyledTableCellClass>
                      <StyledTableCellClass width="150px" Align="center">
                        {etiquetas.Home.Et_lblDocumento}
                      </StyledTableCellClass>
                      <StyledTableCellClass width="85px" Align="center">
                        {etiquetas.General.Et_tbnEliminar}
                      </StyledTableCellClass>
                    </StyledTableRowHeaderClass>
                  </TableHead>
                  <TableBody>
                    {ListaRequisitosAdmision.length > 0 ? (
                      ListaRequisitosAdmision.map((registro) => {
                        return (
                          <StyledTableRowClass key={registro.adrRequirementId}>
                            <StyledTableCellClass component="th" scope="row">
                              {
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {registro.aprAcceptRequirement ? (
                                      <Checkbox
                                        disabled={registro.adrApproved}
                                        checked={registro.aprAcceptedByStudent}
                                        style={{ padding: "0px 5px" }}
                                        name="FileRequired"
                                        color="primary"
                                        inputProps={{
                                          "aria-label": "secondary checkbox",
                                        }}
                                        onChange={(e) => {
                                          handleChangeAccept(
                                            registro.aprProgramReqId,
                                            e.target.checked
                                          );
                                        }}
                                      />
                                    ) : null}
                                  </div>

                                  <div>
                                    {!(registro.aprHyperlink === "") &&
                                    !(registro.aprHyperlink === null) ? (
                                      <Button
                                        variant="text"
                                        onClick={() =>
                                          abrirNuevoTab(registro.aprHyperlink)
                                        }
                                        style={{
                                          textTransform: "inherit",
                                          textDecoration: "underline",
                                          color: "#283593",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        {registro.reqDescription}
                                      </Button>
                                    ) : (
                                      registro.reqDescription
                                    )}
                                  </div>
                                </div>
                              }
                            </StyledTableCellClass>

                            <StyledTableCellClass width="150px" Align="center">
                              {registro.aprFileRequired === false ? (
                                etiquetas.General.Et_NoAplica
                              ) : (
                                <Tooltip title={registro.fileName}>
                                  <div>
                                    <label
                                      htmlFor={
                                        "button-file-" +
                                        registro.adrRequirementId
                                      }
                                    >
                                      <Input
                                        id={
                                          "button-file-" +
                                          registro.adrRequirementId
                                        }
                                        type="file"
                                        disabled={
                                            registro.adrApproved ||
                                            registro.attachments === true
                                          }
                                        onChange={(e) => {
                                          guardarDataArchivo(
                                            e,
                                            registro.adrRequirementId
                                          );
                                        }}
                                        onClick={inputhandleClick}
                                      />
                                      <Button
                                        disabled={
                                         registro.adrApproved ||
                                         registro.attachments === true
                                        }
                                        fullWidth
                                        sx={{
                                          backgroundColor: "#F6F8FB",
                                          color: "#283593",
                                          border: "1px solid #283593",
                                          "&:hover": {
                                            backgroundColor: "#EDF0F4",
                                          },
                                        }}
                                        id="attachments"
                                        variant="contained"
                                        component="span"
                                        disableElevation
                                        startIcon={
                                          <BackupIcon
                                            style={{ color: "#283593" }}
                                          />
                                        }
                                      >
                                        <Typography
                                          noWrap
                                          style={{
                                            color: "#283593",
                                            width: 80,
                                            backgroundColor: "transparent",
                                          }}
                                        >
                                          {registro.attachments === true
                                            ? registro.fileName
                                            : etiquetas.Home.Et_lblAdjuntar}
                                        </Typography>
                                      </Button>
                                    </label>
                                  </div>
                                </Tooltip>
                              )}
                            </StyledTableCellClass>
                            <StyledTableCellClass width="85px" Align="center">
                              <div style={styleTable.BodyContainerButtoms}>
                                {registro.aprFileRequired === false ? (
                                  <IconButton
                                    style={styleTable.BodyButtoms}
                                    disabled
                                  >
                                    <BlockIcon fontSize="normal" />
                                  </IconButton>
                                ) : (
                                  <Tooltip
                                    title={etiquetas.General.Et_tbnEliminar}
                                  >
                                    <IconButton
                                      style={styleTable.BodyButtoms}
                                      disabled={
                                        registro.attachments === false ||
                                        registro.adrApproved
                                      }
                                      onClick={(e) => {
                                        handleClick(
                                          e,
                                          registro.adrRequirementId
                                        );
                                      }}
                                    >
                                      <DeleteIcon fontSize="normal" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </div>
                            </StyledTableCellClass>
                          </StyledTableRowClass>
                        );
                      })
                    ) : (
                      <StyledTableRowClass>
                        <StyledTableCellClass colSpan={3}>
                          {etiquetas.General.Et_tblTableEmty}
                        </StyledTableCellClass>
                      </StyledTableRowClass>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      </CardContent>

      <DialogoEliminarGenerico
        id="Eliminar-Aula"
        deviceIs={deviceIs}
        TextoElementoEliminar={NombreArchivoEliminar}
        funcionEliminar={EliminarArchivoEstudiante}
      />
    </Fragment>
  );
};

export default Requisitos;
